import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializeVoiceActorSystem, getVoiceActorSystemStatus } from '../utils/voiceLabIntegrationInit';

/**
 * Component that initializes the Voice Actor management system when the application starts
 * This component should be added to the App.jsx file
 */
const VoiceActorSystemInitializer = () => {
  const dispatch = useDispatch();
  const [isInitialized, setIsInitialized] = useState(false);
  const userProfile = useSelector(state => state.user.profile);
  const userId = userProfile?.data?.userId;

  // Initialize the Voice Actor management system when the component mounts
  // and when the user logs in (userId changes)
  useEffect(() => {
    const initialize = async () => {
      if (userId && !isInitialized) {
        try {
          console.log('Initializing Voice Actor management system...');
          await initializeVoiceActorSystem();
          setIsInitialized(true);
          console.log('Voice Actor management system initialized successfully');

          // Log the system status
          const status = getVoiceActorSystemStatus();
          console.log('Voice Actor System Status:', status);
        } catch (error) {
          console.error('Error initializing Voice Actor management system:', error);
        }
      }
    };

    initialize();
  }, [userId, isInitialized]);

  // This component doesn't render anything
  return null;
};

export default VoiceActorSystemInitializer;
